export const constants = {
  BE_BASE_URL: {
    PROD: `https://nayaxcapital.com`,
    STAGE: `https://stage.nayaxcapital.com`,
    TEST: `https://test.nayaxcapital.com`,
    LOCAL: `http://localhost:8080`,
  },
  BE_ENDPOINTS: {
    SHOW_OFFER: `/offers/show-offer`,
    VERIFY_AUTHORIZE: `/mitigation/execute-mitigation/verify`,
    GET_CREDIT: `/customer-data-app/get-credit`,
    POST_EVENT: '/page/post-event',
    FETCH_LOCALIZED_DATA: `/localization/fetch-localized-data-by-lng`,
  },
  IMAGE_URLS: {
    RIGHT_ARROW: 'https://nayax-capital-appsmith.s3.eu-west-1.amazonaws.com/right_arrow_icon.png',
  },
  PSP: {
    US: {
      SK: {
        PROD: process.env.REACT_APP_US_CRDX_ST_KEY_PROD,
        SANDBOX: process.env.REACT_APP_US_CRDX_ST_KEY,
      },
      MID: {
        PROD: process.env.REACT_APP_US_CRDX_MERCHANT_ID_PROD,
        SANDBOX: process.env.REACT_APP_US_CRDX_MERCHANT_ID,
      },
      SCRIPT: {
        PROD: process.env.REACT_APP_PSP_SCRIPT_PROD,
        SANDBOX: process.env.REACT_APP_PSP_SCRIPT,
      },
    },
    UK: {
      SK: {
        PROD: process.env.REACT_APP_UK_CRDX_ST_KEY_PROD,
        SANDBOX: process.env.REACT_APP_UK_CRDX_ST_KEY,
      },
      MID: {
        PROD: process.env.REACT_APP_UK_CRDX_MERCHANT_ID_PROD,
        SANDBOX: process.env.REACT_APP_UK_CRDX_MERCHANT_ID,
      },
      SCRIPT: {
        PROD: process.env.REACT_APP_PSP_SCRIPT_PROD,
        SANDBOX: process.env.REACT_APP_PSP_SCRIPT,
      },
    },
    US_LLC: {
      SK: {
        PROD: process.env.REACT_APP_LLC_CRDX_ST_KEY_PROD,
        SANDBOX: process.env.REACT_APP_LLC_CRDX_ST_KEY,
      },
      MID: {
        PROD: process.env.REACT_APP_LLC_CRDX_MERCHANT_ID_PROD,
        SANDBOX: process.env.REACT_APP_LLC_CRDX_MERCHANT_ID,
      },
      SCRIPT: {
        PROD: process.env.REACT_APP_PSP_SCRIPT_PROD,
        SANDBOX: process.env.REACT_APP_PSP_SCRIPT,
      },
    },
  },
  PSP_IDS: {
    CREDORAX_US: 1,
    CREDORAX_UK: 2,
    CREDORAX_US_LLC: 3,
  },
  PRODUCT_IDS: {
    MCA: 1,
    FIXED_PAYMENT: 2,
    FIXED_PERIOD: 3,
    MCA_WITH_MIN: 4,
    MCA_PLUS_CPT_WITH_MIN: 5,
    CALCULATED_FIXED_PAYMENT: 6,
    RENT: 7,
    LEASE_2: 8,
    FIXED_PAYMENT_PLAN: 9,
    MCA_CAPITAL: 10,
  },
  MITIGATION_TYPES: {
    AUTHORIZE: 'authorize',
    AUTHORIZE_WITH_DP: 'authorize with dp',
    DOWN_PAYMENT: 'down payment',
    VERIFY: 'verify',
  },
  TEXTS: {
    ENSURE: 'and ensure future payments.',
    SETUP_DISCLAIMER: [
      'When you accept the offer, you agree to set up your devices within the setup period ({setupPeriod} days).',
      'If you fail to complete the setup within the agreed time period, your credit card will be charged the remaining amount.',
    ],
    AUTHORIZE: {
      ACTIVATION_NOTICE:
        'In order to activate your offer, please enter your card information. Your card will be used to verify your identity.',
    },
    AUTHORIZE_WITH_DP: {
      ACTIVATION_NOTICE:
        'In order to activate your offer, please enter your card information. Your card will be used to collect your {currency+amount} down payment.',
    },
    DP: {
      ACTIVATION_NOTICE:
        'In order to activate your offer, please enter your card information. Your card will be used to collect your {currency+amount} down payment.',
    },
    VERIFY: {
      ACTIVATION_NOTICE:
        'In order to activate your offer, please enter your card information. Your card will be used to verify your identity.',
    },
    BUSINESS_TERMS: {
      FIXED_AMOUNT: [
        'When you accept the offer, you agree to a scheduled fixed-payment plan of {offerSubstring}.',
        'If your total cashless sales do not cover this payment, your card will be charged the remaining amount.',
      ],
      MIN_INSTALLMENT: [
        'When you accept the offer, you agree to pay {share} of your total cashless sales until the order is paid in full.',
        'If your total cashless sales do not reach the minimum amount of {currencySymbol}{minInstallment} per {plannedCycle}, your card will be charged the difference.',
      ],
      MIN_INSTALLMENT_PLUS_CPT: [
        'When you accept the offer, you agree to pay {share}  of your total cashless sales plus {cost_per_tx} {smallCurrencyUnitName} per transaction, until the order is paid in full.',
        'If your total cashless sales do not reach the minimum amount of {currencySymbol}{minInstallment} per {plannedCycle}, your card will be charged the difference.',
      ],
    },
    OFFER_DESCRIPTIONS: {
      MCA: 'a {billingCycle} deduction of {share}% will be taken from your total cashless sales until the order is paid in full.',
      MCA_WITH_MIN:
        'a {plannedCycle} deduction of {share}% will be taken from your total cashless sales until the order is paid in full.',
      FIXED:
        'A total of {plannedAmount} will be deducted from your {plannedCycle} cashless sales until the order is paid in full',
      MIN_INSTALLMENT: [
        'When you accept the offer, you agree to pay {share} of your total cashless sales until the order is paid in full.',
        'If your total cashless sales do not reach the minimum amount of {currencySymbol}{minInstallment} per {plannedCycle}, your card will be charged the difference.',
      ],
      MIN_INSTALLMENT_PLUS_CPT: [
        'When you accept the offer, you agree to pay {share}  of your total cashless sales plus {cost_per_tx} {smallCurrencyUnitName} per transaction, until the order is paid in full.',
        'If your total cashless sales do not reach the minimum amount of {currencySymbol}{minInstallment} per {plannedCycle}, your card will be charged the difference.',
      ],
    },
  },
  ASSET_URLS: {
    LOADER: 'https://nayax-capital-appsmith.s3.eu-west-1.amazonaws.com/loader_2.gif',
  },
  OPERATING_ENTITIES: {
    NAYAX: {
      ID: 1,
      PRIVACY_URL: 'https://www.nayax.com/legal/nayax-general-privacy-policy/',
      TERMS_URL: 'https://www.nayax.com/terms-conditions/',
    },
  },
};
